import React from 'react';

export default function UserProfileEditActions({ onSave, onCancel, isLoading = false }) {
  return (
    <>
      <div className="d-grid gap-2 mb-3">
        <button onClick={onSave} className="btn btn-primary" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save Changes'}
        </button>
        <button onClick={onCancel} className="btn btn-link text-muted" disabled={isLoading}>
          Discard Changes
        </button>
      </div>
    </>
  );
}
